import { GCSAssetFetcher } from "@sourceful/shared-utils/cdn-utils";
import { apiConfig } from "../apiConfig";
import { v4 as uuid } from "uuid";

/*
    This fetcher must be used when fetching from out gcloud bucket to enforce the use of a cacheKey
    Without these, we will have errors when trying to fetch the same resource across different subdomains as 
    the CORs response is cached for a specific subdomain but the browser tries to use it on other subdomains, causing
    CORs errors - the Vary: Origin header seems to have no effect

*/

export const gcsAssetFetcher = new GCSAssetFetcher(
  apiConfig.cloudBucket.baseUrl,
  apiConfig.cloudBucket.folders
);

export const useCdnCacheKey = () => {
  const origin =
    typeof window !== "undefined" && window.location.origin ? window.location.origin : uuid(); // fallback to busting the cache to be on the safe side
  return origin;
};
